import React, { useState, useEffect } from 'react';
import { adminApi } from '../../repositories/admin'; // Adjust path as necessary
import Swal from 'sweetalert2';
import MultiSelect from '../../PitchFormPage/components/MultiSelect/MultiSelect';

interface EditLabelModalProps {
  isOpen: boolean;
  onClose: () => void;
  labelId: number;
  initialName: string;
  initialType: string;
  initialAvailableDSPs: string[];
  onSave: (name: string, type: string, availableDSPs: string[]) => void;
}

const EditLabelModal: React.FC<EditLabelModalProps> = ({
  isOpen,
  onClose,
  labelId,
  initialName,
  initialType,
  initialAvailableDSPs,
  onSave,
}) => {
  const [name, setName] = useState(initialName);
  const [type, setType] = useState(initialType);
  const [dsps, setDsps] = useState<string[]>(initialAvailableDSPs);
  const musicPlatforms = [
    "Select All",
    'Spotify',
    'Apple Music', 
    'Deezer for Creators',
    'SoundCloud',
    'TIDAL',
    'Amazon Music',
    'Audiomack',
    'YouTube',
    'Email'
  ];

  useEffect(() => {
    setName(initialName);
    setType(initialType);
    setDsps(initialAvailableDSPs);
  }, [initialName, initialType, initialAvailableDSPs]);

  const handleSave = async () => {
    try {
      if (!name || !type || dsps.length === 0) {
        return Swal.fire('Error', 'Please fill in all fields', 'error');
      }
      onSave(name, type, dsps.filter((dsp) => dsp !== 'Select All'));
      onClose();
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Error updating label', 'error');
    }
  };

  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose} // clicking the background closes the modal
    >
      <div
        className="relative w-full max-w-md p-6 bg-white shadow-lg rounded-2xl"
        onClick={(e) => e.stopPropagation()} // prevent modal content click from closing
      >
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-800">Edit Label</h2>
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">Company Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mt-4">
          <label className="block mb-1 text-sm font-medium text-gray-700">Label Type</label>
          <select
            value={type || ""}
            onChange={(e) => setType(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
              <option value="">Select Type</option>
              <option value="independent">Independent Label</option>
              <option value="major">Major Label</option>
              <option value="management">Management</option>
              <option value="distributor">Distributor</option>
              <option value="music-services">Music Services</option>
          </select>
        </div>
        <div className="mt-4">
          <label className="block mb-1 text-sm font-medium text-gray-700">Available DSPs for this company</label>
          <MultiSelect value={dsps} onChange={setDsps} options={musicPlatforms} placeholder="Select DSPs" />
        </div>
        <div className="flex justify-between mt-6">
          <button
            onClick={handleSave}
            className="w-full py-2 text-white transition duration-200 bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Save Changes
          </button>
          <button
            onClick={onClose}
            className="w-full py-2 ml-2 text-white transition duration-200 bg-gray-500 rounded-lg hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditLabelModal;